import script from "./CallbackModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CallbackModal.vue?vue&type=script&setup=true&lang=js"

import "./CallbackModal.vue?vue&type=style&index=0&id=ba499906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba499906"]])

export default __exports__